import styled from "@emotion/styled";

export const Container = styled.div`
  background-color: #222222;
`;
